export const STORE_ORDER_FORM_DATA = 'STORE_ORDER_FORM_DATA';
export const CLEAR_ORDER_STATE = 'CLEAR_ORDER_STATE';
export const STORE_ORDER = 'STORE_ORDER';
export const SET_IS_CREATE_FROM_CALENDAR = 'SET_IS_CREATE_FROM_CALENDAR';